<section *ngIf="!readOnly">
    <div>
        <h3>Shifts</h3>
        <div class="form-row three">
            <div class="form-group">
                <label>Type</label>
                <select 
                    #shiftBlockSelect name="shiftBlockSelect" 
                    class="body-dropdown" 
                    [(ngModel)]="selectedShiftBlockOption"
                    (change)="resetShiftBlockOptions(shiftBlockSelect.value)">
                        <option *ngFor="let shiftBlockOption of shiftBlockOptions" [value]="shiftBlockOption.id">
                            {{ shiftBlockOption.description }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <ul class="options">
                    <li>
                        <label class="closed">
                            <input 
                                type="checkbox" 
                                name="closed" 
                                [disabled]="!canCloseSelectedShiftBlockType"
                                [(ngModel)]="selectedClosedSchedule" 
                                value="true"> 
                            Closed
                        </label>
                    </li>
                </ul>
            </div>
        </div>
        <div class="form-row five staffing-acuity-select">
            <div class="form-group">
                <label>Block Size (In Hours)</label>
                <select class="body-dropdown" [disabled]="selectedClosedSchedule" name="shiftBlockSize" [(ngModel)]="selectedBlockSize">
                    <option *ngFor="let shiftBlockSize of shiftBlockSizes" [ngValue]="shiftBlockSize">
                        {{ shiftBlockSize }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>Start Time</label>
                <select class="body-dropdown" [disabled]="selectedClosedSchedule" name="startTime" [(ngModel)]="selectedStartTime">
                    <option *ngFor="let shiftBlockHour of shiftBlockStartHours" [ngValue]="shiftBlockHour.hour">
                    {{ shiftBlockHour.description }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>End Time</label>
                <select class="body-dropdown margin-right10" [disabled]="selectedClosedSchedule" name="endTime" [(ngModel)]="selectedEndTime">
                    <option *ngFor="let shiftBlockHour of shiftBlockEndHours" [ngValue]="shiftBlockHour.hour">
                        {{ shiftBlockHour.description }}
                    </option>
                </select>
                <button type="button" [disabled]="!addButtonEnabled" (click)="addShiftScheduleWithDebounce()">Add shift</button>
            </div> 
            <div class="form-group targetwhpuos-div" *ngIf="isTotalUosConfigured">
                <div *ngIf="showVariableWhpuos">
                    <label>Variable Target WHPUOS</label>
                    <div class="workflow-input">
                        <input type="number" disabled name="variableTargetWHPUOS" [ngModel]="costCenter.ancillaryConfiguration.variableTargetWHPUOS">
                    </div>
                </div>
                <div *ngIf="showFixedWhpuos">
                    <label>Fixed Target WHPUOS</label>
                    <div class="workflow-input">
                        <input type="number" disabled name="fixedTargetWHPUOS" [ngModel]="costCenter.ancillaryConfiguration.fixedTargetWHPUOS">
                    </div>
                </div>
            </div>           
        </div>
    </div>
    <span class="warning inline" [hidden]="!conflictingSchedule">
        <span class="icon-warning2"></span> 
        You have already scheduled shift blocks during this time.
    </span>
</section>
